import { useEffect, useRef } from "react";
import FormCreator from "../../../components/forms/FormCreator";
import { EditAdmissionCommitteeFormData } from "../data/EditAdmissionCommitteeFormData";
import SwalAlert from "../../../services/swalService/SwalService";
import Buttons from "../../../components/ui/button/Buttons";
import { useState } from "react";
import { decryptAESID } from "../../../utils/Encryption";
import {
    useLazyGetCommitteeApprovalByMemberIdQuery, useResetPasswordForWebMemberMutation
} from '../../../app/services/AdmissionBoardApproval/AdmissionBoardServiceApi';
import { getAuditContext } from "../../../lib/authenticationLibrary";

const EditMemberForm = (props) => {
    const viewCommitteeListDataRef = useRef();
    const selectedId = props.selectedId ? decryptAESID(props.selectedId) : 0;
    const [viewList, setViewList] = useState(EditAdmissionCommitteeFormData)
    const { success, error } = SwalAlert();
    const audit = getAuditContext();
    const [getMemberDetailById, { isSuccess: isSuccessMemberById, isFetching: isFetchingMemberbyID, data: memberlistData }] = useLazyGetCommitteeApprovalByMemberIdQuery();
    const [addEditCommitteApprovalMember, { isLoading: isAddMemberLoading, isSuccess: isAddMemberSuccess, data: addMemberResponse }] = useResetPasswordForWebMemberMutation();

    useEffect(() => {
        if (selectedId) {
            getMemberDetailById(selectedId);
        }
    }, []);

    useEffect(() => {
        if (!isFetchingMemberbyID && isSuccessMemberById && memberlistData) {
            let Data = { ...viewList }
            const { name, email } = memberlistData;
            Data.initialState = {
                name,
                email,
            };
            setViewList(Data);
        }
    }, [isFetchingMemberbyID, isSuccessMemberById, memberlistData]);

    useEffect(() => {
        if (!isAddMemberLoading && isAddMemberSuccess && addMemberResponse) {
            if (!addMemberResponse.hasError) {
                success("Record has been updated successfully.");
            } else {
                error(addMemberResponse.errorMessage);
            }
        }
    }, [isAddMemberLoading, isAddMemberSuccess, addMemberResponse]);

    const handleUpdate = () => {
        const formData = viewCommitteeListDataRef.current.getFormData();
        if (!formData) return;
        if (formData?.password === formData?.confirmPassword) {
            const request = {
                IPASMemberId: 0,
                Password: formData.password || null,
                EmailAddress: formData.email || memberlistData?.email,
                Name: formData.name || memberlistData?.name,
                AdminId: memberlistData?.adminID,
                RoleId: memberlistData?.roleId,
                UpdatedBy: audit.adminUserId,
                UpdatedAppId: audit.appId
            }
            addEditCommitteApprovalMember(request)
        }
        else {
            error("The passwords do not match. Please try again.", "");
        }
    }

    return (<>
        <div className='row mt-4'>
            <FormCreator ref={viewCommitteeListDataRef} config={viewList} />
            <div className='col-lg-1 d-flex justify-content-start'>
                <Buttons
                    buttonText="Save"
                    buttonTypeClassName="success-btn ml-2 mt-4"
                    onClick={handleUpdate}
                />
            </div>

        </div>
    </>)
}
export default EditMemberForm;